export const SEO_DATA = {
  title: `Blog, Jobs in tech & More | JobsHash`,
  description: `Find next tech job on JobsHash. Search across thousands of top developer jobs by salary, location & tech stack. Blog.`,
  image: `https://static.jobshash.com/default-og.png`,
};
